// Committee Create
export const createCommitteeList = 'committee-create/list'
export const createCommitteeGetList = 'committee-create/getlist'
export const createCommitteeStore = 'committee-create/store'
export const createCommitteeUpdate = 'committee-create/update'
export const createCommitteeToggleStatus = 'committee-create/toggle-status'
export const createCommitteeDelete = 'committee-create/destroy'
// Manage Agenda
export const manageAgendaList = 'committee-agenda/list'
export const manageAgendaStore = 'committee-agenda/store'
export const manageAgendaUpdate = 'committee-agenda/update'
export const manageAgendaToggleStatus = 'committee-agenda/toggle-status'
export const manageAgendaDelete = 'committee-agenda/destroy'
// Meeting Minute
export const meetingMinuteList = 'committee-metting-minute/list'
export const meetingMinuteStore = 'committee-metting-minute/store'
export const meetingMinuteUpdate = 'committee-metting-minute/update'
export const meetingMinuteToggleStatus = 'committee-metting-minute/toggle-status'
export const meetingMinuteDelete = 'committee-metting-minute/destroy'
// Manage Expenses
export const manageExpensesList = 'committee-expenses/list'
export const manageExpensesStore = 'committee-expenses/store'
export const manageExpensesUpdate = 'committee-expenses/update'
export const committeeExpensesToggleStatus = 'committee-expenses/toggle-status'
export const manageExpensesDelete = 'committee-expenses/destroy'
